import { render, staticRenderFns } from "./Gaarkeuken.vue?vue&type=template&id=dd410404&"
import script from "./Gaarkeuken.vue?vue&type=script&lang=ts&"
export * from "./Gaarkeuken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports